module.exports = __webpack_public_path__ + "static/images/part1.428ae80.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/openPlatform/part1.png
// module id = 7bD4
// module chunks = 1